export default "__VITE_ASSET__BqTHwoiK__"